import React, { useContext } from "react"
import { DataContext } from "../../components/Context";
import Swal from 'sweetalert2'
import { PDFDownloadLink } from '@react-pdf/renderer';
import "./style.css"
import { Link } from "react-router-dom";
import BasicDocument from "../../components/BasicDocument/BasicDocument";
import { FaFilePdf } from "react-icons/fa";

const Cart = ({ addToCart, decreaseQty, deleteQty }) => {
  // Stpe: 7   calucate total of items

  // prodcut qty total
  const {
    baseImage,
    setCartItem,
    CartItem,
    errorDolarAPI,
  } = useContext(DataContext);
  const total = Intl.NumberFormat('de-DE').format(CartItem.reduce((precio, item) => precio + item.qty * item.precio, 0));


  const vaciarCarrito = () => {
    Swal.fire({
      title: '¿Queres limpiar el carrito?',
      text: "Esta acción no se puede revertir",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si, Vaciar Carrito'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire(
          'Eliminado!',
          'Productos eliminados correctamente.',
          'success',
          setCartItem([])
        )
      }
    })
  }

  // const renderPdf = () => {
  //   ReactPDF.render(<BasicDocument />, `${__dirname}/example.pdf`);
  // }



  return (
    <>
      <section className='cart-items'>
        <div className='cart_container'>
          {/* if hamro cart ma kunai pani item xaina bhane no diplay */}

          <div className='cart-details'>
            {CartItem.length === 0 && <h1 className='no-items product'>No hay artículos en el carrito</h1>}

            {/* yasma hami le cart item lai display garaaxa */}
            {CartItem.map((item) => {
              const productQty = item.precio * item.qty

              return (
                <>
                  <div className='cart-list product' key={item.id}>
                    <button className='removeCartButton' onClick={() => deleteQty(item)}>
                      <i className='fa-solid fa-xmark'></i>
                    </button>
                    <div className='img'>
                      <img src={baseImage + item.imagen} alt={item.nombre} />
                    </div>
                    <div className='cart-info-product'>
                      <h3>{item.nombre}</h3>
                      <h4>
                      {errorDolarAPI ? "USD" : "AR$"} {Intl.NumberFormat('de-DE').format(item.precio)} * {item.qty}
                      </h4>
                      <h4 >
                        <span>{errorDolarAPI ? "USD" : "AR$"} {Intl.NumberFormat('de-DE').format(productQty)}</span>
                      </h4>
                      {item.descuento > 0 ? <h5 style={{ color: '#e94560' }}>Descuento: {item.descuento}%</h5> : null}
                    </div>
                    <div className='cart-items-function'>
                    </div>
                    {/* stpe: 5
                    product ko qty lai inc ra des garne
                    */}
                    <div className='cartControl'>
                      <button className='incCart' onClick={() => addToCart(item)}>
                        <i className='fa-solid fa-plus'></i>
                      </button>
                      <button className='desCart' onClick={() => decreaseQty(item)}>
                        <i className='fa-solid fa-minus'></i>
                      </button>
                      
                    </div>
                  </div>
                </>
              )
            })}
          </div>

          <div className='cart-total product'>
            <h2>Resumen de la compra</h2>
            <div className='d_flex_precio_total'>
              <h4>Precio Total :</h4>
              <h3>{errorDolarAPI ? "USD" : "AR$"} {total}</h3>
            </div>

            <div className="buttonsCart_container">
              {CartItem.length > 0 ? <button className="whatsapp_button_consult"><a href={`https://api.whatsapp.com/send?phone=+542612565651&text=Hola! Acabo de seleccionar unos productos y necesito asesoría: %0D%0A${CartItem.map((value, index) => (

                `%0D%0A %0D%0A|| Producto ${index + 1}: ${value.nombre} - %0D%0A %0D%0A Cantidad: ${value.qty}%0D%0A`

                // %0D%0A Precio Individual: ${JSON.stringify(Intl.NumberFormat('de-DE').format(value.precio))}%0D%0A
              ))
                }%0D%0A || Precio Total: ${total}`} target="_blank">Consultar <i className="fa-brands fa-whatsapp"></i></a></button> : null}

              {CartItem.length > 0 ? <button className="vaciarCarritoButton" onClick={vaciarCarrito}>Vaciar Carrito</button> : null}
              {CartItem.length > 0 ? <Link to="/cotizacion"><button className="cotizarPDFButton">Cotización <FaFilePdf/></button></Link> : null}



            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Cart
